import { useContext } from 'react';

import { WWContext, type WWContextValue } from '../components/WWContext';
import { isWwsWeddingWebsiteV2, DatePreference } from '../types/graphql';
import dateRangeFormatted from './dateFormatter/dateRangeFormatted';
import dateTimeFormatted, {
  type DateFormat,
} from './dateFormatter/dateTimeFormatted';

export const TBD_MESSAGE = 'Date To Be Announced';

function useDateDisplayWithFormat(
  specifyFormat?: 'natural' | 'short' | undefined
): string | null {
  const { data } = useContext<WWContextValue>(WWContext);

  if (isWwsWeddingWebsiteV2(data?.weddingWebsiteResult)) {
    const weddingDate = data?.weddingDatePreferences?.weddingDate;

    const season = data?.weddingDatePreferences?.season;

    const year = data?.weddingDatePreferences?.year;

    const weddingDateFormat = data?.weddingDatePreferences?.weddingDateFormat;

    const weddingDateRangeStart =
      data?.weddingDatePreferences?.weddingDateRangeStart;

    const weddingDateRangeEnd =
      data?.weddingDatePreferences?.weddingDateRangeEnd;

    const preference = data?.weddingDatePreferences?.datePreference;

    const weddingEventTime = data?.weddingDatePreferences?.weddingEventTime;

    // 1. HIDE DATE
    if (preference === DatePreference.Tba) {
      return TBD_MESSAGE;
    }

    // 2. NOT SURE YET: no data
    if (preference === DatePreference.None) {
      return null;
    }

    // 3. MULTI DATE RANGE
    if (preference === DatePreference.Range) {
      if (weddingDateRangeStart) {
        if (specifyFormat === 'short') {
          return dateRangeFormatted(
            weddingDateRangeStart,
            weddingDateRangeEnd,
            {
              month: 'numeric',
            }
          );
        }

        return dateRangeFormatted(weddingDateRangeStart, weddingDateRangeEnd);
      }
    }

    // 4. EXACT DATE WEDDING DATE
    if (preference === DatePreference.Exact && weddingDate) {
      const isWordyFormat = ['verbose', 'ornate'].includes(
        weddingDateFormat || ''
      );

      const format: DateFormat = (
        isWordyFormat
          ? `${weddingDateFormat || ''}DateOnly`
          : weddingDateFormat || ''
      ) as DateFormat;

      const theFormat: DateFormat | null | undefined = specifyFormat || format;

      const dateWithTime =
        weddingEventTime && weddingDate
          ? `${weddingDate} ${weddingEventTime} UTC`
          : weddingDate;

      return dateTimeFormatted(dateWithTime, theFormat);
    }

    // 5. SEASON YEAR
    if (preference === DatePreference.Season) {
      return `${season || ''} ${year || ''}`;
    }
  }

  return null;
}

export default useDateDisplayWithFormat;
